export default [
  {
    header: "Menu",
    icon: "AlarmIcon",
    title: "home",
    route: "inicio",
    children: [
      {
        title: "VaaS",
        icon: "-",
        children: [
          {
            title: "Camera Manager",
            icon: "-",
            resource: "Home",
            action: "read",
            children: [
              {
                title: "cm_master_account.title",
                icon: "-",
                route: "master_account",
                resource: "CameraManager",
                action: "read_masters_accounts",
              },
              {
                title: "reseller.title",
                icon: "-",
                route: "reseller",
                resource: "CameraManager",
                action: "read_resellers",
              },
              {
                title: "Cameras",
                header: "camera",
                icon: "-",
                route: "camera",
                resource: "CameraManager",
                action: "read",
              },
              {
                title: "status_cameras.name",
                icon: "-",
                route: "status_cameras",
                resource: "CameraManager",
                action: "read_status",
              },
            ],
          },
          {
            title: "safr.title",
            header: "safr_master_accounts",
            icon: "-",
            resource: "Home",
            action: "read",
            children: [
              {
                title: "Cameras",
                header: "safr_cameras",
                icon: "-",
                route: "safr_cameras",
                resource: "SafrCamera",
                action: "read",
              },
              {
                title: "Master Accounts",
                header: "safr_master_accounts",
                icon: "-",
                route: "safr_master_accounts",
                resource: "SafrMasterAccount",
                action: "read",
              },
              {
                title: "safr.accessClearances",
                icon: "-",
                route: "safr_access_clearances",
                resource: "SafrAccessClearance",
                action: "read",
              },
            ],
          },
          {
            title: "EE VMS",
            icon: "-",
            resource: "Home",
            action: "read",
            children: [
              {
                title: "Master Accounts",
                header: "bridge_master_account",
                icon: "-",
                route: "bridge_master_account",
                resource: "Bridge",
                action: "read_masters_accounts",
              },
              {
                title: "Accounts",
                icon: "-",
                route: "account",
                resource: "Bridge",
                action: "read_accounts",
              },
              {
                title: "Bridges",
                icon: "-",
                route: "bridge",
                resource: "Bridge",
                action: "read_bridge",
              },
              {
                title: "Cameras",
                header: "bridge_camera",
                icon: "-",
                route: "bridge_camera",
                resource: "Bridge",
                action: "read",
              },
              {
                title: "presets_ptz.title",
                icon: "-",
                route: "presets",
                resource: "CameraBridge",
                action: "read_presets",
              },
            ],
          },
          {
            title: "luxriot.title",
            icon: "-",
            children: [
              {
                title: "Master Accounts",
                header: "luxriot_master_accounts",
                icon: "-",
                route: "luxriot_master_accounts",
                resource: "LuxriotMasterAccount",
                action: "read",
              },
              {
                title: "Cameras",
                header: "luxriot_cameras",
                icon: "-",
                route: "luxriot_cameras",
                resource: "LuxriotCameras",
                action: "read",
              },
            ],
          },
          {
            title: "omnicloud",
            header: "cameras_omnicloud",
            icon: "-",
            resource: "Home",
            action: "read",
            children: [
              {
                title: "Master Accounts",
                header: "omnicloud_master_account",
                icon: "-",
                route: "omnicloud_master_account",
                resource: "MasterAccount",
                action: "read",
              },
              {
                title: "Cameras",
                header: "omnicloud_camera",
                icon: "-",
                route: "omnicloud_camera",
                resource: "CameraOmnicloud",
                action: "read",
              },
              {
                title: "omniview_reseller.title",
                icon: "-",
                route: "omniview_reseller",
                resource: "OmniviewReseller",
                action: "read",
              },
            ],
          },
          {
            title: "secur_os",
            header: "cameras_securos",
            icon: "-",
            resource: "Home",
            action: "read",
            children: [
              {
                title: "Master Accounts",
                header: "securos_master_account",
                icon: "-",
                route: "securos_master_account",
                resource: "SecurosMasterAccount",
                action: "read",
              },
              {
                title: "Cameras",
                header: "securos_camera",
                icon: "-",
                route: "securos_camera",
                resource: "CameraSecurOS",
                action: "read",
              },
            ],
          },
          {
            title: "dahua_camera.dahua",
            icon: "-",
            resource: "Home",
            action: "read",
            children: [
              {
                title: "dahua_dvr.title",
                icon: "-",
                route: "dahua_dvr",
                resource: "DahuaDvr",
                action: "read",
              },
              {
                title: "dahua_camera.title",
                icon: "-",
                route: "dahua_camera",
                resource: "DahuaCamera",
                action: "read",
              },
            ],
          },
          {
            title: "hanwha_camera.hanwha",
            icon: "-",
            resource: "Home",
            action: "read",
            children: [
              {
                title: "hanwha_dvr.title",
                icon: "-",
                route: "hanwha_dvr",
                resource: "HanwhaDvr",
                action: "read",
              },
              {
                title: "hanwha_camera.title",
                icon: "-",
                route: "hanwha_camera",
                resource: "HanwhaCamera",
                action: "read",
              },
              {
                title: "logs.title",
                icon: "-",
                route: "hanwha_logs",
                resource: "HanwhaLog",
                action: "read",
              },
              {
                title: "hanwha_alarm_profile.title",
                icon: "-",
                route: "hanwha_alarm_profiles",
                resource: "HanwhaAlarmProfile",
                action: "read",
              },
            ],
          },
          {
            title: "hikvision_dvr.section",
            icon: "-",
            resource: "Home",
            action: "read",
            children: [
              {
                title: "hikvision_master_accounts.title",
                icon: "-",
                route: "hikvision_master_accounts",
                resource: "HikvisionMasterAccounts",
                action: "read",
              },
              {
                title: "hikvision_dvr.title",
                icon: "-",
                route: "hikvision_dvr",
                resource: "HikvisionDvr",
                action: "read",
              },
              {
                title: "hikvision_camera.title",
                icon: "-",
                route: "hikvision_cameras",
                resource: "HikvisionCamera",
                action: "read"
              }
            ]
          },
          {
            title: "axis_body_cam.title",
            icon: "-",
            resource: "Home",
            action: "read",
            children: [
              {
                title: "axis_body_cam.overview.title",
                icon: "-",
                route: "axis_body_cam",
                resource: "AxisBodyCam",
                action: "read",
              },
              {
                title: "axis_body_cam.devices.title",
                icon: "-",
                route: "axis_body_cam_devices",
                resource: "AxisBodyCamDevice",
                action: "read",
              },
              {
                title: "axis_body_cam.system_controllers.title",
                icon: "-",
                route: "axis_body_cam_system_controllers",
                resource: "AxisBodyCamSystemController",
                action: "read",
              },
              {
                title: "axis_body_cam.recordings.title",
                icon: "-",
                route: "axis_body_cam_recordings",
                resource: "AxisBodyCamRecording",
                action: "read",
              },
              {
                title: "axis_body_cam.users.title",
                icon: "-",
                route: "axis_body_cam_users",
                resource: "AxisBodyCamUser",
                action: "read",
              },
            ],
          },
          {
            title: "generic_devices.title",
            icon: "-",
            resource: "Home",
            action: "read",
            children: [
              {
                title: "proxy_rtsp_server.title",
                icon: "-",
                route: "proxy_rtsp_server",
                resource: "ProxyRtspServer",
                action: "read",
              },
              {
                title: "generic_devices.title",
                icon: "-",
                route: "generic_devices",
                resource: "GenericDevice",
                action: "read",
              },
            ],
          },
          {
            title: "recording_request.title",
            icon: "-",
            route: "recording_request",
            resource: "Video",
            action: "request_record_video",
          },
          {
            title: "bookmark.title",
            icon: "-",
            resource: "Home",
            action: "read",
            children: [
              {
                title: "bookmark.categories",
                icon: "-",
                route: "bookmark",
                resource: "Video",
                action: "manage_request_record_video",
              },
            ],
          },
          {
            title: "analytics",
            header: "analytics",
            icon: "-",
            resource: "Home",
            action: "read",
            children: [
              {
                title: "detection_event.title",
                icon: "-",
                route: "detection_event",
                resource: "DetectionEvent",
                action: "read",
              },
              {
                title: "detection_event.ms_title",
                icon: "-",
                route: "ms_detection_event",
                resource: "MsDetectionEvent",
                action: "read",
              },
              {
                title: "facial_recognition.facial_recognition",
                icon: "-",
                resource: "Home",
                action: "read",
                children: [
                  {
                    title: "safr.title",
                    header: "safr_events",
                    icon: "-",
                    resource: "Home",
                    action: "read",
                    children: [
                      {
                        title: "safr.events",
                        icon: "-",
                        route: "safr_events",
                        resource: "SafrEvents",
                        action: "read",
                      },
                      {
                        title: "safr.groups",
                        icon: "-",
                        route: "safr_groups",
                        resource: "SafrGroups",
                        action: "read",
                      },
                      {
                        title: "safr.people",
                        icon: "-",
                        route: "safr_people",
                        resource: "SafrPeople",
                        action: "read",
                      },
                    ],
                  },
                  {
                    title: "luna.title",
                    icon: "-",
                    resource: "Home",
                    action: "read",
                    children: [
                      {
                        title: "luna.master_account.title",
                        icon: "-",
                        route: "luna_master_account",
                        resource: "LunaMasterAccount",
                        action: "read",
                      },
                      {
                        title: "luna.list.title",
                        icon: "-",
                        route: "luna_list",
                        resource: "LunaList",
                        action: "read",
                      },
                      {
                        title: "luna.face.title",
                        icon: "-",
                        route: "luna_face",
                        resource: "LunaFace",
                        action: "read",
                      },
                      {
                        title: "facial_recognition.title",
                        icon: "-",
                        route: "facial_recognition",
                        resource: "FaceRecognition",
                        action: "read_match",
                      },
                      {
                        title: "luna.facestream.title",
                        icon: "-",
                        route: "luna_facestream",
                        resource: "LunaFacestream",
                        action: "read",
                      },
                    ],
                  },
                  {
                    title: "ntechlab.title",
                    icon: "-",
                    resource: "Home",
                    action: "read",
                    children: [
                      {
                        title: "ntechlab.master_account.title",
                        icon: "-",
                        route: "ntechlab_master_account",
                        resource: "NtechlabMasterAccount",
                        action: "read",
                      },
                      {
                        title: "ntechlab.watch_list.title",
                        icon: "-",
                        route: "ntechlab_watchlist",
                        resource: "NtechlabWatchlist",
                        action: "read",
                      },
                      {
                        title: "ntechlab.face.title",
                        icon: "-",
                        route: "ntechlab_face_recognition",
                        resource: "NtechlabFace",
                        action: "read",
                      },
                      {
                        title: "ntechlab.camera.title",
                        icon: "-",
                        route: "ntechlab_camera",
                        resource: "NtechlabCamera",
                        action: "read",
                      }
                    ],
                  },
                  {
                    title: "omnicloud_fr.title",
                    icon: "-",
                    resource: "Home",
                    action: "read",
                    children: [
                      {
                        title: "omnicloud_fr.watch_list.title",
                        icon: "-",
                        route: "omnicloud_watchlist",
                        resource: "OmnicloudFrList",
                        action: "read",
                      },
                      {
                        title: "omnicloud_fr.face.title",
                        icon: "-",
                        route: "omnicloud_face_recognition",
                        resource: "OmnicloudFrFaces",
                        action: "read",
                      },
                    ],
                  },
                ],
              },
              {
                title: "lpr.title",
                icon: "-",
                resource: "Home",
                action: "read",
                children: [
                  {
                    title: "plate_list._name",
                    icon: "-",
                    route: "plate_list",
                    resource: "PlateList",
                    action: "read",
                  },
                  {
                    title: "plate.title",
                    icon: "-",
                    route: "plate",
                    resource: "Plate",
                    action: "read",
                  },
                  {
                    title: "lpr_matches._name",
                    icon: "-",
                    route: "lpr_matches",
                    resource: "Lpr",
                    action: "read_match",
                  },
                ],
              },
              {
                title: "intelexvision.title",
                icon: "-",
                children: [
                  {
                    title: "intelexvision.servers",
                    icon: "-",
                    route: "server",
                    resource: "IntelexvisionServer",
                    action: "read",
                  },
                  {
                    title: "intelexvision_alarm_type.alarm_type",
                    icon: "-",
                    route: "intelexvision_alarm_type",
                    resource: "IntelexvisionAlarmType",
                    action: "read",
                  },
                  {
                    title: "intelexvision_event.title",
                    icon: "-",
                    route: "analytic_record",
                    resource: "AnalyticRecord",
                    action: "read",
                  },
                ],
              },
              {
                title: "ai_analytics_servers.title",
                header: "ai_analytics_servers.title",
                icon: "-",
                children: [
                  {
                    title: "ai_analytics_servers.servers",
                    icon: "-",
                    resource: "AiAnalyticServer",
                    action: "read",
                    route: "ai_analytics_servers",
                  },
                  {
                    title: "ai_analytics_servers.devices",
                    icon: "-",
                    resource: "AiAnalyticServer",
                    action: "read",
                    route: "ai_analytics_devices",
                  },
                  {
                    title: "ai_analytics_servers.logs",
                    icon: "-",
                    resource: "AiAnalyticLog",
                    action: "read",
                    route: "ai_analytics_servers_logs",
                  },
                ],
              },
              {
                title: "vlm_analyzer.menu_title",
                icon: "-",
                resource: "VlmAnalyzer",
                action: "read",
                children: [
                  {
                    title: "vlm_analyzer.cameras",
                    icon: "-",
                    route: "vlm_analyzer_cameras",
                    resource: "VlmAnalyzer",
                    action: "read",
                  },
                  //{
                  //  title: "vlm_analyzer.monitoring",
                  //  icon: "-",
                  //  route: "vlm_analyzer_monitoring",
                  //  resource: "VlmAnalyzer",
                  //  action: "read",
                  //},
                ],
              },
            ],
          },
          {
            title: "video_watermarks.title",
            icon: "-",
            route: "video_watermarks",
            resource: "VideoWaterMark",
            action: "read",
          },
          {
            title: "digital_signature.title",
            icon: "-",
            route: "validate_signature",
            resource: "ValidateSignature",
            action: "read",
          },
        ],
      },
      {
        title: "tenants.title",
        icon: "-",
        children: [
          {
            title: "tenants.all",
            icon: "-",
            route: "tenant",
            resource: "Tenant",
            action: "read",
          },
          {
            title: "master_tenants.title",
            icon: "-",
            route: "master_tenant",
            resource: "MasterTenant",
            action: "read",
          },
          // {
          //   title: "incident_list.title",
          //   icon: "-",
          //   route: "incident_list",
          //   resource: "Incident",
          //   action: "read",
          // },
          // {
          //   title: "chart_incident.title",
          //   icon: "-",
          //   route: "incident_chart",
          //   resource: "Incident",
          //   action: "read_chart",
          // },
          // {
          //   title: "log_incident.title",
          //   icon: "-",
          //   route: "log_incident",
          //   resource: "LogIncident",
          //   action: "read",
          // },
          {
            title: "device_tag.title",
            icon: "-",
            route: "device_tags",
            resource: "DeviceTag",
            action: "read",
          },
          {
            title: "tools.title",
            icon: "-",
            resource: "Tools",
            action: "read",
            children: [
              {
                title: "layout_builder.title",
                icon: "-",
                route: "layouts",
                resource: "Layouts",
                action: "read",
              },
              {
                title: "token.title",
                icon: "-",
                route: "token",
                resource: "Token",
                action: "read",
              },
              {
                title: "token_omnitag.title",
                icon: "-",
                route: "tokens_omnitag",
                resource: "TokenOmnitag",
                action: "read",
              },
            ],
          },

          {
            title: "inventory.title",
            icon: "-",
            resource: "Inventory",
            action: "read",
            children: [
              {
                title: "inventory.title",
                icon: "-",
                route: "inventory",
                resource: "Inventory",
                action: "read",
              },
              {
                title: "inventory_brand_catalog.menu",
                icon: "-",
                route: "inventory_brand_catalog",
                resource: "InventoryBrandCatalog",
                action: "read",
              },
              {
                title: "inventory_project_catalog.menu",
                icon: "-",
                route: "inventory_project_catalog",
                resource: "InventoryProjectCatalog",
                action: "read",
              },
              {
                title: "inventory_equipment_type_catalog.menu",
                icon: "-",
                route: "inventory_equipment_type_catalog",
                resource: "InventoryEquipmentTypeCatalog",
                action: "read",
              },
            ]
          },
          {
            title: "maintenance.title",
            icon: "-",
            resource: "MaintenanceCompany",
            action: "read",
            children: [
              {
                title: "maintenance.maintenance_companies",
                icon: "-",
                route: "maintenance_company",
                resource: "MaintenanceCompany",
                action: "read",
              },
              {
                title: "maintenance.maintenance_crew",
                icon: "-",
                route: "maintenance_crew",
                resource: "MaintenanceCrew",
                action: "read",
              },
              {
                title: "maintenance.maintenance_templates",
                icon: "-",
                route: "maintenanceTemplates",
                resource: "MaintenanceTemplate",
                action: "read",
              },
              {
                title: "maintenance.maintenance_forms",
                icon: "-",
                route: "maintenanceForms",
                resource: "MaintenanceForm",
                action: "read",
              },
              {
                title: "service_orders.title",
                icon: "-",
                route: "service_orders",
                resource: "ServiceOrder",
                action: "read",
              },
            ]
          },
          {
            title: "risk.operational_procedures",
            icon: "-",
            children: [
              {
                title: "simulacrum.title",
                icon: "-",
                children: [
                  {
                    title: "simulacrum.template.title",
                    icon: "-",
                    route: "simulacrumTemplates",
                    resource: "SimulacrumTemplate",
                    action: "read",
                  },
                  {
                    title: "simulacrum.simulacrums_title",
                    icon: "-",
                    route: "risk_simulacrums",
                    resource: "Simulacrum",
                    action: "read",
                  },
                ],
              },
              {
                title: "operational_procedure_exercise.title",
                icon: "-",
                children: [
                  {
                    title: "operational_procedure_exercise.template.title",
                    icon: "-",
                    route: "risk_operational_procedure_templates",
                    resource: "OperationalProcedureTemplate",
                    action: "read",
                  },
                  {
                    title: "operational_procedure_exercise.title",
                    icon: "-",
                    route: "risk_operational_procedure",
                    resource: "OperationalProcedure",
                    action: "read",
                  },
                ],
              },
              {
                title: "security_self_audit.title",
                icon: "-",
                children: [
                  {
                    title: "security_self_audit.template.title",
                    icon: "-",
                    route: "securitySelfAuditTemplates",
                    resource: "SecuritySelfAuditTemplate",
                    action: "read",
                  },
                  {
                    title: "security_self_audit.title",
                    icon: "-",
                    route: "securitySelfAudits",
                    resource: "SecuritySelfAudit",
                    action: "read",
                  },
                ]
              },
              {
                title: "risk.title",
                icon: "-",
                children: [
                  {
                    title: "risk.template.title",
                    icon: "-",
                    route: "riskTemplates",
                    resource: "RiskTemplate",
                    action: "read",
                  },
                  {
                    title: "risk.evaluation.title",
                    icon: "-",
                    route: "risk_evaluations",
                    resource: "RiskEvaluation",
                    action: "read",
                  },
                ]
              },
              {
                title: "bau_complement.title",
                icon: "-",
                children: [
                  {
                    title: "bau_complement.cctv_tracking",
                    icon: "-",
                    children: [
                      {
                        title: "bau_complement.cctv_tracking",
                        icon: "-",
                        route: "risk_bau_complements",
                        resource: "BauComplement",
                        action: "read",
                      },
                      {
                        title: "bau_complement.form_templates",
                        icon: "-",
                        route: "risk_bau_complement_templates",
                        resource: "BauComplementTemplate",
                        action: "read",
                      },
                    ],
                  },
                  {
                    title: "bau_complement.property_visits",
                    icon: "-",
                    route: {
                      name: "OperationalSecurityFormAnswersBau",
                      query: { "bau-complements": "" },
                    },
                    resource: "BauComplement",
                    action: "view_menu_form_answers",
                  },
                ],
              },
            ]
          },
          {
            title: "operational_security.title",
            resource: "OpSecurityForms",
            action: "menu",
            icon: "-",
            children: [
              {
                title: "operational_security.template.title",
                icon: "-",
                route: "operationalSecurityTemplates",
                resource: "OpSecurityFormTemplate",
                action: "read",
              },
              {
                title: "operational_security.evaluation.title",
                icon: "-",
                route: "OperationalSecurityFormAnswers",
                resource: "OpSecurityFormAnswers",
                action: "read",
              },
              {
                title: "operational_security.crisis_form.title",
                icon: "-",
                route: "crisis_form",
                resource: "CrisisForm",
                action: "read",
              },
              {
                title: "operational_security.operational_processes.title",
                icon: "-",
                route: "external_personnel_access_control",
                resource: "ExternalPersonnelAccessControl",
                action: "read",
              },
              {
                title: "operational_security.activities.title",
                icon: "-",
                route: "external_personnel_access_control_activity",
                resource: "ExternalPersonnelAccessControlActivity",
                action: "read",
              }
            ]
          },
          {
            title: "testing.title",
            icon: "-",
            children: [
              {
                title: "testing.penetration.title",
                icon: "-",
                route: "penetrationTesting",
                resource: "Testing",
                action: "read",
              },
              {
                title: "testing.security_box.title",
                icon: "-",
                route: "securityBoxTesting",
                resource: "SecurityBoxTesting",
                action: "read",
              },
            ]
          },
          {
            title: "planning.title",
            icon: "-",
            route: "planning",
            resource: "Planning",
            action: "read",
          },
          {
            title: "policy_exception.title",
            icon: "-",
            route: "policyExceptions",
            resource: "PolicyException",
            action: "read",
          },
          {
            title: "training.title",
            icon: "-",
            route: "trainingModule",
            resource: "Trainings",
            action: "read",
          },
          {
            title: "tenants.file_storage",
            icon: "-",
            children: [
              {
                title: "tenants.store.tenant_storage",
                icon: "-",
                route: "tenants_storage",
                resource: "Filesystem",
                action: "read",
              },
              {
                title: "tenants.file.file_explorer",
                icon: "-",
                route: "tenant_files_explorer",
                resource: "FileExplorer",
                action: "read",
              },
              {
                title: "storage_provider.title",
                icon: "-",
                route: "storage_provider",
                resource: "StorageProvider",
                action: "read",
              }
            ]
          },
          {
            title: "distribution_list.title",
            icon: "-",
            route: "distribution_list",
            resource: "DistributionList",
            action: "read",
          },
          {
            title: "providers.title",
            icon: "-",
            children: [
              {
                title: "companies.title",
                icon: "-",
                resource: "Providers",
                action: "read",
                route: "companies",
              },
              {
                title: "employees.title",
                icon: "-",
                resource: "Employees",
                action: "read",
                route: "employees",
              },
            ]
          },
          {
            title: "patrol_logs.title",
            icon: "-",
            children: [
              {
                title: "patrol_logs.patrol_log.title",
                icon: "-",
                route: "patrol_logs",
                resource: "PatrolLogs",
                action: "read",
              },
              {
                title: "patrol_logs.unit_log.title",
                icon: "-",
                route: "unit_log",
                resource: "UnitLogs",
                action: "read",
              },
              {
                title: "patrol_logs.unit_commander.title",
                icon: "-",
                route: "unit_commanders",
                resource: "UnitCommanders",
                action: "read",
              },
              {
                title: "patrol_logs.revision_code.title",
                icon: "-",
                route: "revision_codes",
                resource: "RevisionCodes",
                action: "read",
              },
            ],
          },
          {
            title: "billing.title",
            icon: "-",
            children: [
              {
                title: "billing_holiday.title",
                icon: "-",
                route: "billing_holiday",
                resource: "BillingHoliday",
                action: "read",
              },
              {
                title: "billing_price.title",
                icon: "-",
                route: "billing_price",
                resource: "BillingPrice",
                action: "read",
              },
              {
                title: "billing_finance.title",
                icon: "-",
                route: "billing_finance",
                resource: "BillingFinance",
                action: "read",
              },
            ],
          },
        ], // Tenants
      },
      {
        title: "users.title",
        icon: "-",
        children: [
          {
            title: "All Users",
            icon: "-",
            route: "user",
            resource: "User",
            action: "read",
          },
          {
            title: "profiles.title",
            icon: "-",
            route: "profile",
            resource: "Profile",
            action: "read",
          },
          {
            title: "permissions.title",
            icon: "-",
            route: "permission",
            resource: "Permission",
            action: "read",
          },
          {
            title: "group.title",
            icon: "-",
            route: "group",
            resource: "Group",
            action: "read",
          },
          {
            title: "user_group_selection_option.title",
            icon: "-",
            route: "user_group_selection_option",
            resource: "UserGroupSelectionOption",
            action: "read",
          },
          {
            title: "user_group_selection_option.title_history",
            icon: "-",
            route: "user_group_selection_option_history",
            resource: "UserGroupSelectionOptionHistory",
            action: "read",
          },
          {
            title: "Asignación de Regiones",
            icon: "-",
            route: "user_assigned_regions",
            resource: "UserAssignedRegion",
            action: "read",
          },
          {
            title: "assigned_video_tours.title",
            icon: "-",
            route: "user_assigned_video_tours",
            resource: "UserAssignedVideoTour",
            action: "read",
          },
          {
            title: "users_app.title",
            icon: "-",
            route: "users_app",
            resource: "UsersApp",
            action: "read_users_app",
          },
          {
            title: "Turnos",
            icon: "-",
            route: "user-shifts",
            resource: "UserShifts",
            action: "read",
          },
          {
            title: "users_rh.title",
            icon: "-",
            route: "users_rh",
            resource: "UserRh",
            action: "read",
          },
          {
            title: "helpdesk.title",
            icon: "-",
            children: [
              {
                title: "Catálogo",
                icon: "-",
                children: [
                  {
                    title: "Siniestro",
                    icon: "-",
                    children: [
                      {
                      title: "Tipo",
                      icon: "-",
                      route: "helpdesk_sinister_type",
                      resource: "HelpdeskSinisterType",
                      action: "read",
                      },
                      {
                      title: "Subtipo",
                      icon: "-",
                      route: "helpdesk_sinister_subtype",
                      resource: "HelpdeskSinisterSubType",
                      action: "read",
                      },
                    ]
                  },
                  {
                    title: "Incidente",
                    icon: "-",
                    children: [
                      {
                      title: "Tipo",
                      icon: "-",
                      route: "helpdesk_incident_type",
                      resource: "HelpdeskSinisterType",
                      action: "read",
                      },
                      {
                      title: "Subtipo",
                      icon: "-",
                      route: "helpdesk_incident_subtype",
                      resource: "HelpdeskSinisterSubType",
                      action: "read",
                      },
                    ]
                  },
                  // {
                  //   title: "Tramo carretero",
                  //   icon: "-",
                  //   route: "helpdesk_roads",
                  //   resource: "HelpdeskRoads",
                  //   action: "read",
                  // },
                ]
              },
              {
                title: "Tickets",
                icon: "-",
                route: "helpdesk_tickets",
                resource: "HelpdeskTicket",
                action: "read",
              },
            ],
          },
        ],
      },
      {
        title: "alarm.title",
        icon: "-",
        children: [
          {
            title: "alarm.all",
            icon: "-",
            route: "alarm",
            resource: "Alarm",
            action: "read_history",
          },
          {
            title: "seproban.title",
            icon: "-",
            route: "seproban_events",
            resource: "SeprobanRequest",
            action: "read",
          },
          {
            title: "types_alarms.title",
            icon: "-",
            route: "type_alarm",
            resource: "TypeAlarm",
            action: "read",
          },
          {
            title: "type_alarm_category.title",
            icon: "-",
            route: "type_alarm_category",
            resource: "TypeAlarmCategory",
            action: "read",
          },
          {
            title: "alarm_level.title",
            icon: "-",
            route: "alarm_level",
            resource: "AlarmLevel",
            action: "read",
          },
          {
            title: "alarm_comment.title",
            icon: "-",
            route: "alarm_comment",
            resource: "AlarmComment",
            action: "read",
          },
          {
            title: "alarm_views.title",
            icon: "-",
            route: "alarm_views",
            resource: "AlarmViews",
            action: "read",
          },
          {
            title: "purge_alarm.title",
            icon: "-",
            route: "alarm_purge",
            resource: "PurgeAlarm",
            action: "read",
          },
          {
            title: "schedule_alarm.title",
            icon: "-",
            route: "schedule_alarm",
            resource: "ScheduleAlarm",
            action: "read",
          },
          {
            title: "alarm_rules.title",
            icon: "-",
            route: "alarm-rules",
            resource: "Alarm",
            action: "readRule",
          },
          {
            title: "institutions.institutions",
            icon: "-",
            route: "institutions",
            resource: "Institutions",
            action: "read",
          },
          {
            title: "alarm_groups.title",
            icon: "-",
            route: "alarm-groups",
            resource: "AlarmGroup",
            action: "read",
          },
        ],
      },
      {
        title: "unit.title",
        icon: "-",
        children: [
          {
            title: "unit.all",
            icon: "-",
            resource: "Units",
            route: "unit",
            action: "read",
          },
          {
            title: "centers.title",
            icon: "-",
            route: "center",
            resource: "Center",
            action: "read",
          },
          {
            title: "sectors.title",
            icon: "-",
            route: "sector",
            resource: "Sector",
            action: "read",
          },
          {
            title: "country.title",
            icon: "-",
            route: "countries",
            resource: "Country",
            action: "read",
          },
          {
            title: "region.title",
            icon: "-",
            route: "region",
            resource: "Region",
            action: "read",
          },
          {
            title: "municipality.title",
            icon: "-",
            route: "municipality",
            resource: "Municipality",
            action: "read",
          },
          {
            title: "unit_groups.title",
            icon: "-",
            resource: "UnitGroups",
            action: "read",
            route: "unit_groups",
          },
          {
            title: "facility_category.title",
            icon: "-",
            resource: "FacilityCategory",
            action: "read",
            route: "facility_categories",
          },
          {
            title: "unit_deactivation_catalog.title",
            icon: "-",
            resource: "UnitDeactivationCatalog",
            action: "read",
            route: "unit_deactivation_catalog",
          },
          {
            title: "custom_timezones.title",
            icon: "-",
            resource: "CustomTimezones",
            action: "read",
            route: "custom_tiemzones",
          },
          {
            title: "teams.title",
            icon: "-",
            resource: "Teams",
            action: "read",
            route: "teams",
          },
          {
            title: "directory.title",
            icon: "-",
            resource: "Directory",
            action: "read",
            route: "directory",
          },
          {
            title: "pisos.title",
            icon: "-",
            resource: "UnitFloor",
            action: "read",
            route: "unit-floors",
          },
          {
            title: "brigades.title",
            icon: "-",
            resource: "Brigade",
            action: "read",
            route: "brigades",
          },
          {
            title: "holliday.title",
            icon: "-",
            resource: "Holliday",
            action: "read",
            route: "hollidays",
          }
        ],
      },
      {
        title: "iot",
        icon: "-",
        children: [
          {
            title: "buttons.title",
            icon: "-",
            children: [
              {
                title: "buttons.all",
                icon: "-",
                route: "buttons",
                resource: "Button",
                action: "read",
              },
              {
                title: "buttons.button_type",
                icon: "-",
                route: "button_type",
                resource: "Button",
                action: "read_type",
              },
            ],
          },
          {
            title: "swift.title",
            icon: "-",
            children: [
              {
                title: "swift_sensor.title",
                icon: "-",
                route: "swift_sensor",
                resource: "SwiftSensor",
                action: "read",
              },
              {
                title: "swift_account.title",
                icon: "-",
                route: "swift_account",
                resource: "SwiftAccount",
                action: "read",
              },
              {
                title: "swift_collector.title",
                icon: "-",
                route: "swift_collector",
                resource: "SwiftCollector",
                action: "read",
              },
            ],
          },
          {
            title: "access_devices.title",
            icon: "-",
            route: "access_devices",
            resource: "AccessDevice",
            action: "read",
          },
          {
            title: "density_device.density_devices",
            icon: "-",
            children: [
              {
                title: "density_device.title",
                icon: "-",
                route: "density_master_account",
                resource: "DensityMasterAccount",
                action: "read",
              },
              {
                title: "density_device.density_devices",
                icon: "-",
                route: "density_device",
                resource: "DensityDevice",
                action: "read",
              },
            ],
          },
          {
            title: "pacom.pacom",
            icon: "-",
            resource: "Home",
            action: "read",
            children: [
              {
                title: "pacom.masterAccounts",
                icon: "-",
                route: "pacom_master_accounts",
                resource: "PacomMasterAccounts",
                action: "read",
              },
              {
                title: "pacom.sites",
                icon: "-",
                route: "pacom_sites",
                resource: "PacomSites",
                action: "read",
              },
              {
                title: "pacom.schema_actions",
                icon: "-",
                route: "pacom_schema_actions",
                resource: "PacomActions",
                action: "read",
              },
              {
                title: "pacom.schemaTypes",
                icon: "-",
                route: "pacom_schema_types",
                resource: "PacomSchemaTypes",
                action: "read",
              },
              {
                title: "pacom.devices",
                icon: "-",
                route: "pacom_devices",
                resource: "PacomDevice",
                action: "read",
              },
              {
                title: "pacom.typeAlarms",
                icon: "-",
                route: "pacom_alarm_types",
                resource: "PacomAlarmType",
                action: "read",
              },
              {
                title: "pacom.alarms",
                icon: "-",
                route: "pacom_alarms",
                resource: "PacomAlarm",
                action: "read",
              },
              {
                title: "pacom.logs",
                icon: "-",
                route: "pacom_logs",
                resource: "PacomLog",
                action: "read",
              },
            ],
          },
          {
            title: "intelbras.title",
            icon: "-",
            resource: "Home",
            action: "read",
            children: [
              {
                title: "intelbras.profiles",
                icon: "-",
                route: "intelbras_profiles",
                resource: "IntelbrasProfile",
                action: "read",
              },
              {
                title: "intelbras.panels",
                icon: "-",
                route: "intelbras_panels",
                resource: "IntelbrasPanel",
                action: "read",
              },
              // {
              //   title: "intelbras.typeAlarms",
              //   icon: "-",
              //   route: "intelbras_alarm_types",
              //   resource: "Intelbras",
              //   action: "read",
              // },
              {
                title: "intelbras.alarms",
                icon: "-",
                route: "intelbras_alarms",
                resource: "IntelbrasAlarm",
                action: "read",
              },
              {
                title: "intelbras.logs",
                icon: "-",
                route: "intelbras_logs",
                resource: "IntelbrasLog",
                action: "read",
              }
            ],
          },
          {
            title: "dmp.title",
            icon: "-",
            resource: "Home",
            action: "read",
            children: [
              //{
              //  title: "dmp.servers",
              //  icon: "-",
              //  route: "dmp_servers",
              //  resource: "Dmp",
              //  action: "read",
              //},
              {
                title: "dmp.profiles.title",
                icon: "-",
                route: "dmp_profiles",
                resource: "Dmp",
                action: "view_profiles",
              },
              {
                title: "dmp.panels",
                icon: "-",
                route: "dmp_panels",
                resource: "Dmp",
                action: "view_panels",
              },
              {
                title: "dmp.alarms",
                icon: "-",
                route: "dmp_alarms",
                resource: "Dmp",
                action: "view_alarms",
              },
                {
                title: "dmp.compositeAlarms",
                icon: "-",
                route: "composite_alarms",
                resource: "Dmp",
                action: "view_composite_alarms",
              },
              {
                title: "dmp.logs",
                icon: "-",
                route: "dmp_logs",
                resource: "Dmp",
                action: "view_logs",
              },
              {
                title: "dmp.templates",
                icon: "-",
                route: "dmp_templates",
                resource: "Dmp",
                action: "view_templates",
              }
            ]
          },
          {
            title: "bosch.title",
            icon: "-",
            resource: "Home",
            action: "read",
            children: [
              {
                title: "bosch.panels",
                icon: "-",
                route: "bosch_panels",
                resource: "BoschPanel",
                action: "read",
              },
              {
                title: "bosch.logs",
                icon: "-",
                route: "bosch_logs",
                resource: "BoschLog",
                action: "read",
              },
              {
                title: "bosch.profiles",
                icon: "-",
                route: "bosch_profiles",
                resource: "BoschProfile",
                action: "read",
              }
            ]
          },
          {
            title: "victronenergy.title",
            icon: "-",
            children: [
              {
                title: "victronenergy.master_account.title",
                icon: "-",
                route: "victronenergy_master_account",
                resource: "VictronenergyMasterAccount",
                action: "read",
              },
              {
                title: "victronenergy.sites.title",
                icon: "-",
                route: "victronenergy_sites",
                resource: "VictronenergySite",
                action: "read",
              },
              {
                title: "victronenergy.devices.title",
                icon: "-",
                route: "victronenergy_devices",
                resource: "VictronenergyDevice",
                action: "read",
              },
            ],
          },
        ],
      },
      {
        title: "logs.title",
        icon: "-",
        children: [
          {
            title: "logs.system_logs",
            icon: "-",
            route: "microservice_logs",
            resource: "MicroserviceLogs",
            action: "read",
          },
          {
            title: "traffic.title",
            icon: "-",
            resource: "Traffic",
            action: "read",
            route: "traffic",
          },
          {
            title: "commands.logs.title",
            icon: "-",
            route: "commandLogs",
            resource: "CommandLog",
            action: "read",
          },
          {
            title: "action_plan.list.title",
            icon: "-",
            route: "actionPlanLogs",
            resource: "ActionPlanLog",
            action: "read",
          },
          {
            title: "totem_logs.title",
            icon: "-",
            route: "totem_logs",
            resource: "TotemLog",
            action: "read",
          },
        ],
      },
      {
        title: "automation.title",
        icon: "-",
        children: [
          {
            title: "scripts.title",
            icon: "-",
            route: "command",
            resource: "Command",
            action: "read",
          },
          {
            title: "schedule_task.title",
            icon: "-",
            route: "schedule_task",
            resource: "ScheduleTask",
            action: "read",
          },
          {
            title: "alarms_commands.title",
            icon: "-",
            route: "workflow",
            resource: "Workflow",
            action: "read",
          },
          {
            title: "action_plan.title",
            icon: "-",
            route: "action-plan",
            resource: "ActionPlan",
            action: "read",
          },
          {
            title: "action_plan.documentActionPlan.title",
            icon: "-",
            route: "document_action_plan",
            resource: "DocumentActionPlan",
            action: "read",
          },
        ],
      },
      {
        title: "VOIP",
        icon: "-",
        resource: "Home",
        action: "read",
        children: [
          {
            title: "iotcomms.title",
            icon: "-",
            resource: "Home",
            action: "read",
            children: [
              {
                title: "iotcomms_master_account.title",
                icon: "-",
                route: "iotcomms_master_account",
                resource: "IotcommsMasterAccount",
                action: "read",
              },
              {
                title: "type_device_interphone.title",
                icon: "-",
                route: "type_device_interphone",
                resource: "TypeDeviceInterphone",
                action: "read",
              },
              {
                title: "device_interphone.title",
                icon: "-",
                route: "device_interphone",
                resource: "DeviceInterphone",
                action: "read",
              },
              {
                title: "sip.view.title",
                icon: "-",
                route: "sip_call",
                resource: "SipCall",
                action: "read_record_call",
              },
            ],
          },
          {
            title: "omnicloud",
            header: "pbx_omnicloud",
            icon: "-",
            resource: "Home",
            action: "read",
            children: [
              {
                title: "pbx_master_account.title",
                icon: "-",
                route: "pbx_master_account",
                resource: "PbxMasterAccount",
                action: "read",
              },
              {
                title: "pbx_device.title",
                icon: "-",
                route: "pbx_device",
                resource: "PbxDevice",
                action: "read",
              },
              {
                title: "pbx_ip_block.title",
                icon: "-",
                route: "pbx_ip_block",
                resource: "PbxIpBlock",
                action: "read",
              },
            ],
          },
        ],
      },
    ],
  },
];
